








































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop, Watch, Vue} from 'vue-property-decorator';

import {LoraForwarderStore} from '@/store/lora/LoraForwarder.store';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class LoraForwarderLog extends Mixins<BaseComponent>(BaseComponent) {
  @Prop(Object)
  private forwarderStore!: LoraForwarderStore;

  private autoScroll: boolean = false;

  private expanded: boolean = false;

  private async mounted() {
    this.subscribeScrollListener();
    await this.subscribeLogs();
    this.autoScroll = true;
    this.scrollDown();
  }

  private async beforeDestroy() {
    this.unsubscribeScrollListener();
    await this.forwarderStore.unsubscribeLogs();
  }

  private async subscribeLogs() {
    try {
      this.logger.debug(`Subscribing to forwarder logs`);
      await this.forwarderStore.subscribeLogs();
    } catch (error) {
      Notify.Warn(this.logger, `Could not subscribe to forwarder logs`, error);
    }
  }

  @Watch('forwarderStore.Logs')
  private scrollDown() {
    if (this.autoScroll) {
      const content = document.querySelector('#log-table div');

      if (content) {
        Vue.nextTick(() => {
          content.scrollTop = content.scrollHeight;
        });
      }
    }
  }

  private autoScrollClick() {
    this.autoScroll = !this.autoScroll;
    this.scrollDown();
  }

  private subscribeScrollListener() {
    const content = document.querySelector('#log-table div');

    if (content) {
      content.addEventListener('scroll', this.scrollListener);
    }
  }

  private unsubscribeScrollListener() {
    const content = document.querySelector('#log-table div');

    if (content) {
      content.removeEventListener('scroll', this.scrollListener);
    }
  }

  private scrollListener() {
    const content = document.querySelector('#log-table div');

    if (content) {
      this.autoScroll = content.scrollTop + content.clientHeight >= content.scrollHeight;
    }
  }
}
